var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSinkKitchenDisposal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-53 -147)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 26,
    height: 33,
    x: 53,
    y: 147,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 25,
    height: 32,
    x: 53.5,
    y: 147.5,
    rx: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSinkKitchenDisposal);
export default __webpack_public_path__ + "static/media/RoomSinkKitchenDisposal.dadfe71f54fc017bd3e4b7e15cec99a9.svg";
export { ForwardRef as ReactComponent };